import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LayoutComponent } from '../../../../shared/layouts/layout/layout.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  standalone: true,
  imports: [LayoutComponent, CommonModule, RouterModule],
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent {

  videoUrl: SafeResourceUrl | null = null;
  videoSrc: string = '';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.videoSrc = params['video'];

      if (this.videoSrc) {
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoSrc);
      }
    });
  }

  getVideoType(): string {
    if (!this.videoSrc) return 'unknown';

    if (this.videoSrc.includes('youtube.com') || this.videoSrc.includes('youtu.be')) {
      return 'youtube';
    } else if (this.videoSrc.endsWith('.mp4') || this.videoSrc.endsWith('.webm') || this.videoSrc.endsWith('.ogg')) {
      return 'html5';
    } else {
      return 'iframe';
    }
  }
}
